import { depositConditionFn } from "../conditions/deposit.condition";
import { withdrawalConditionFn } from "../conditions/withdrawal.condition";
import { SurvicateTaskType } from "../enums/survicate.enum";
import { SurvicateConfig } from "../interfaces/survicate.interface";

export const survicateConfig: SurvicateConfig = {
    survicateWindowString: '_sva',
    eventTriggerDelay: 3000,
    paymentOrdersPeriodDays: 3,
    tasks: [
        {
            name: 'triggerEventDeposit',           
            config: {
                type: SurvicateTaskType.Event,
                nameString: 'deposit_survicate',
                condition: depositConditionFn
            }

        },
        {
            name: 'triggerEventWithdrawal',           
            config: {
                type: SurvicateTaskType.Event,
                nameString: 'withdrawal_survicate',
                condition: withdrawalConditionFn
            }

        },
    ]
};